import { CsrStrategy } from "src/api/client-api/csrStrategy/useGetAllStrategy";
import { PayloadWrite } from "src/api/client-api/csrStrategy/useUpsertStrategy";

export type StrategyForm = {
    id: string | undefined;
    name: string;
    description: string;
    campaign: IRI | null;
    endCampaign: IRI | null;
};

export const strategyToForm = (strategy?: CsrStrategy, defaultCampaign?: IRI | null): StrategyForm => ({
    id: strategy?.id,
    name: strategy?.name ?? "",
    description: strategy?.description ?? "",
    campaign: strategy?.campaign ?? defaultCampaign ?? null,
    endCampaign: strategy?.endCampaign ?? null,
});

export const formToStrategyWrite = (strategyForm: StrategyForm): PayloadWrite => ({
    id: strategyForm.id,
    name: strategyForm.name.trim(),
    description: strategyForm.description,
    campaign: strategyForm.campaign ?? "",
    endCampaign: strategyForm.endCampaign,
});
